module.exports = __webpack_public_path__ + "5c76353cdf9b76c5a17ab5ae33fa26eb.png";